export default "__VITE_ASSET__B7F41Kp5__"